export class MapController {
    constructor(CompanyService, $rootScope, $scope, bbWidgetInit,
                GeolocationService, $timeout, $compile, GeneralOptions, bbWidgetPage, BBWidget,
                FormDataStoreService, LoadingService, AlertService, bbGoogleMaps) {

        'njInject';

        this.$rootScope = $rootScope;
        this.CompanyService = CompanyService;
        this.baseCompanies = BBWidget.company.companies;
        this.GeolocationService = GeolocationService;
        this.markers = [];
        this.$timeout = $timeout;

        this.$compile = $compile;
        this.$scope = $scope;
        this.bbWidgetPage = bbWidgetPage;

        // BBWidget wraps up the BB object
        this.BBWidget = BBWidget;
        this.bbWidgetInit = bbWidgetInit;
        this.FormDataStoreService = FormDataStoreService;
        this.AlertService = AlertService;
        this.GeneralOptions = GeneralOptions;
        this.bbGoogleMaps = bbGoogleMaps;

        this.loader = LoadingService.$loader($scope).notLoaded();

        this.defaultOptions = {
            default_zoom: 6,
            can_filter_by_service: false,
            num_search_search_results: 6,
            region_bias: this.BBWidget.company.country_code,
            restrict_search_by_company_country: false,
            geolocation_enabled: true
        };

        // Merge the passed option with default ones
        Object.assign(this.defaultOptions, this.options);


        /*
         * window.isSecureContext might be not supported in some browsers.
         * Set its value checking if the iFrame parent url starts with https
         */
        let isSecureContext = window.isSecureContext;

        // Use this value to hide or show the geolocate button, when geolocation_enabled option
        // is not passed in to component options.
        if (isSecureContext === undefined) {
            const url = (window.location !== window.parent.location)
                ? document.referrer
                : document.location.href;
            isSecureContext = /^https:\/\//.test(url);
        }

        this.geolocation_enabled = this.defaultOptions.geolocation_enabled && isSecureContext;

        FormDataStoreService.init('MapController', this, [
            'query',
            'selectedStore',
            'search_prms'
        ]);

        /*
         *  Retrieve the value passed to the layout attribute
         *  and populate an object which expose the layout type
         *
         *  Passing "radio" means that layout.radio is true, etc...
         *
         *  If no value is passed, the layout.default is set to true
         */
        this.layout = {};


        const layout = this.defaultOptions.layout
            || (GeneralOptions.map_layout === 'default'
            || GeneralOptions.map_layout === undefined
            || GeneralOptions.map_layout === '' ? 'default' : GeneralOptions.map_layout);

        this.layout[layout] = true;


        if (BBWidget.company.hasChildren()) {
            $rootScope.parent_id = BBWidget.company.id;
        } else if (this.$rootScope.parent_id) {
            return bbWidgetInit.initWidget({
                company_id: $rootScope.parent_id,
                first_page: BBWidget.current_page,
                keep_basket: true,
                item_defaults: BBWidget.item_defaults || {}
            });
        } else {
            return bbWidgetInit.initWidget({
                company_id: BBWidget.company.id,
                first_page: null
            });
        }

        /* Restore the previous state if any
         * TODO: take a look at this.
         * I was trying to handle the back button from the next state. It worked for a while, but it stopped working
         * on Chrome at some point.
         * Actually, when hitting the back button, GoogleMap causes an error due to a wrong execution order of
         * component compiling (company-details component) and markers drawing.
         *
         */

        /* This code handled the back button */
        //
        // let prevState = JSON.parse(sessionStorage.getItem('map_state'));
        // if (prevState) {
        //     delete sessionStorage.state;
        //
        //     /*
        //      *  Restore the query/address in the search bar, the result
        //      *  label and the results itself
        //      */
        //     this.query = prevState.query;
        //     this.queryCopy = angular.copy(this.query);
        //     this.results = prevState.results;
        //
        //
        //     // re-draw markers, re-center the map and trigger a map re-load (actually a re-size)
        //     this.drawMarkers(prevState.markerIndex);
        //     this.getCanvas().setCenter({
        //         lat: this.results[prevState.markerIndex].address.lat,
        //         lng: this.results[prevState.markerIndex].address.long
        //     });
        //     google.maps.event.trigger(this.getCanvas(), 'resize');
        // }

        if (BBWidget.company.$has('address')) {
            BBWidget.company.$getAddress().then((address) => {
                BBWidget.company.address = address;
                this.ready = true;
                this.loader.setLoaded();
            });
        } else {
            this.ready = true;
            this.loader.setLoaded();
        }
    }

    /**
     * This method handles the map canvas. Creates a new map instance if none is defined
     * or returns the existing one
     * @returns {google.maps.Map} the map instance
     */
    getCanvas() {
        if (this.mapCanvas) {
            return this.mapCanvas;
        } else {
            this.mapCanvas = new google.maps.Map(document.getElementById('map-canvas'), {});
            return this.mapCanvas;
        }
    }


    /**
     * Show array of results.
     * It deep clones the original data to avoid changes in the data-set, that should be read-only
     * @param data
     * @param sortByDistance
     */
    showResults(data, sortByDistance = true) {
        if (sortByDistance) {
            data = data.sort((prev, next) => prev.distance - next.distance);
        }

        this.results = Object.assign([], data.slice(0, this.defaultOptions.num_search_search_results));

        this.$timeout(() => {
            this.clearMarkers();

            // assume that the center should always be the first company's coordinates
            this.getCanvas().setCenter({lat: this.results[0].address.lat, lng: this.results[0].address.long});
            this.drawMarkers();


            // focus out the search bar
            const activeElement = document.activeElement;
            if (activeElement) {
                activeElement.blur();
            }
        });
    }

    /**
     * Search policy:
     * 1. try to search for an address, if it's an actual locality calculate the distance from the first result
     * to each company we have in the result
     * 2. if no result is returned or no locality is present in the Gmap response, try to search for
     * company name or description, and calculate the distance from the first result again.
     * 3. if everything fails, just display the base companies we already have
     */
    search() {
        this.AlertService.clear();

        if (!this.query || this.query.trim().length < 1) {
            return this.AlertService.raise('MISSING_LOCATION');
        }

        this.loader.notLoaded();

        const googleGeocodeQueryOptions = {
            address: this.query,
            region: this.defaultOptions.region_bias
        };

        if (this.BBWidget.company.$has('address') && this.defaultOptions.restrict_search_by_company_country) {
            googleGeocodeQueryOptions.componentRestrictions = {
                country: this.BBWidget.company.country_code
            };
        }

        /**
         * All the promises are always resolved even if there is an error. That's because we need to
         * analyse all the results and we don't care if ONE of them has an error because we have fallbacks on the
         * other two.
         *
         * i.e. If Google Geocode research fails we have a result with an higher precedence (our, or Places).
         * We raise an error only if all of them have no result
         *
         * @type {Promise}
         */

        const searchForText = new Promise((resolve, reject) => {
            this.CompanyService.queryByText(this.BBWidget.company.id, {text: this.query})
                .then((companies) => {
                    if (companies.length > 0) {
                        resolve(companies);
                    } else {
                        resolve({error: 'NOTHING_FOUND'});
                    }
                })
                .catch((error) => {
                    resolve({error});
                });
        });

        const googlePlaces = new Promise((resolve, reject) => {
            const textSearch = {
                query: this.query
            };

            if (this.BBWidget.company.$has('address')) {
                textSearch.location = new google.maps.LatLng(this.BBWidget.company.address.lat, this.BBWidget.company.address.long);
            }

            new this.bbGoogleMaps.places.PlacesService(this.getCanvas())
                .textSearch(textSearch)
                .then((results, status) => {
                    if (status === 'OK' && results.length > 0) {
                        resolve(results);
                    } else {
                        resolve({error: 'NO_PLACES_FOUND'});
                    }
                });
        });

        const googleGeocode = new Promise((resolve, reject) => {
            new this.bbGoogleMaps.Geocoder()
                .geocode(googleGeocodeQueryOptions)
                .then((results, status) => {
                    if (results[0] !== undefined && (results.length > 0 || results[0].partial_match)) {
                        resolve(results);
                    } else {
                        resolve({error: 'NOTHING_FOUND'});
                    }
                });
        });


        /**
         * Business Logic Here!
         * We decided to trigger all the tree searches at the same time.
         *
         * We search for the company name/description, for a place in Google and for the address in Google.
         *
         * Then we retrieve the coordinates from one of the result, giving a precedence to our result (if any)
         * and then to the google's ones.
         * With these coordinates we search for companies by address
         */
        Promise.all([searchForText, googlePlaces, googleGeocode]).then((values) => {
            const [searchForText, googlePlaces, googleGeocode] = values;

            let coordinates = {};

            let exactResult = [];

            // All of promise have an error
            if (searchForText.error && googlePlaces.error && googleGeocode.error) {
                return Promise.reject(searchForText.error);
            }

            // A company has been found in our database
            if (searchForText.length > 0) {
                coordinates = {
                    lat: searchForText[0].address.lat,
                    long: searchForText[0].address.long
                };

                /*
                * If the Company search by text returns an exact result,
                * add it on the top
                */
                exactResult = [...searchForText];

            } else if (googleGeocode.length > 0) {
                coordinates = {
                    lat: googleGeocode[0].geometry.location.lat(),
                    long: googleGeocode[0].geometry.location.lng()
                };

                if (this.parseAddressComponents(googleGeocode[0].address_components)) {
                    this.query = this.parseAddressComponents(googleGeocode[0].address_components);
                }

            } else if (googlePlaces.length > 0) {
                coordinates = {
                    lat: googlePlaces[0].geometry.location.lat(),
                    long: googlePlaces[0].geometry.location.lng()
                };
                this.query = googlePlaces[0].name;

            }

            const options = {
                coords: coordinates,
                page: 1,
                per_page: this.defaultOptions.num_search_search_results,
                radius: 50
            };

            if (this.BBWidget.current_item.service) {
                options.service_id = this.BBWidget.current_item.service.id;
            }

            return new Promise((resolve, reject) => {
                this.CompanyService
                    .queryByCoords(this.BBWidget.company.id, options)
                    .then((companies) => {
                        if (companies.length > 0) {

                            // Order the whole set by distance
                            let orderedCompanies = this.sortByDistance(companies, coordinates);
                            let shouldSortByDistance = true;

                            // if there's an exact result, use it
                            if (exactResult.length > 0) {
                                /*
                                 * get the ids of the companies already contained in the result.
                                 * We need to avoid duplicates
                                 */
                                const exactResultIds = exactResult.map(ex => ex.id);
                                const filtered = angular.copy(orderedCompanies).filter((comp) => {
                                    return exactResultIds.indexOf(comp.id) === -1;
                                });


                                orderedCompanies = exactResult.concat(...filtered);
                                shouldSortByDistance = false;
                            }

                            // show the new ordered result
                            this.showResults(orderedCompanies, shouldSortByDistance);

                            this.queryCopy = angular.copy(this.query);
                            return resolve(this.queryCopy);

                        } else {
                            reject('NOTHING_FOUND');
                        }
                    });
            });

        }).catch((error) => {
            this.queryCopy = angular.copy(this.query);
            this.results = [];
            this.clearMarkers();
            this.$timeout(() => this.loader.setLoaded());
            this.AlertService.clear();
        });

    }

    geolocate() {
        this.AlertService.clear();

        const options = {
            timeout: 5000,
            maximumAge: 3600000
        };

        this.loader.notLoaded();
        navigator.geolocation.getCurrentPosition(this.geolocateSuccess.bind(this), this.geolocateFail.bind(this), options);
    }

    getDistances(companies, geometry) {
        const localCompanies = Object.assign([], companies);

        return localCompanies.map((company) => {

            const center = {lat: geometry.lat, long: geometry.long};
            const position = {
                lat: company.address.lat,
                long: company.address.long
            };

            company.distance = this.GeolocationService.haversine(center, position);
            return company;
        });
    }

    sortByDistance(companies, coordinates) {
        const distances = this.getDistances(companies, coordinates);
        return distances.sort((prev, next) => prev.distance - next.distance);
    }

    geolocateFail(error) {
        switch (error.code) {
            // case 1) if the user disallow geolocation
            // if the geocode failed because the position was unavailable or the request timed out, raise an alert
            case 1:
            case 2:
            case 3:
                this.loader.setLoaded();
                this.AlertService.clear();
                this.AlertService.raise('GEOLOCATION_ERROR');
                break;
            default:
                this.loader.setLoaded();
        }

    }

    /**
     * Build a meaningful string using the address components returned by google and
     * display the route and the locality
     * @param components
     */
    parseAddressComponents(components) {
        const addressComponents = components
            .filter(ac => ac.types.includes('route') || ac.types.includes('locality'))
            .map(ac => ac.long_name);

        return addressComponents.join(', ');
    }


    /**
     * Query companies using the user coordinates and sort results by distance
     * @param position
     */
    geolocateSuccess(position) {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        const latlng = new google.maps.LatLng(lat, long);
        const coords = {lat, long};

        const googleGeocode = new Promise((resolve, reject) => {
            new this.bbGoogleMaps.Geocoder().geocode({
                latLng: latlng
            }).then((results, status) => {
                resolve(results[0]);
            });
        });



        const bbGeocode = new Promise((resolve, reject) => {
            const options = {
                coords,
                page: 1,
                per_page: this.defaultOptions.num_search_search_results
            };

            if (this.BBWidget.current_item.service) {
                options.service_id = this.BBWidget.current_item.service.id;
            }

            this.CompanyService.queryByCoords(this.BBWidget.company.id, options).then((companies) => {
                resolve(companies);
            }, (error) => {
                reject(error);
            });
        });

        Promise.all([googleGeocode, bbGeocode]).then((values) => {
            const [googleResult, companies] = values;

            /*
             * Retrieve the address components which includes a route or
             * a locality to build a display string
             */
            this.query = this.parseAddressComponents(googleResult.address_components);
            this.queryCopy = angular.copy(this.query);

            // calculate distances for the companies retrieved from the server
            this.showResults(this.sortByDistance(companies, {lat, long}));
        }, (err) => {
            this.loader.setLoaded();
            this.AlertService.clear();
            return this.AlertService.raise('GEOLOCATION_ERROR');
        });
    }


    clearMarkers() {
        if (this.markers.length > 0) {
            this.markers.forEach((m) => {
                m.setMap(null);
            });
            this.markers = [];
        }
    }

    /**
     * This opens the right info window.
     * @param company
     */
    openInfo(company) {
        // Find the open info window and close it
        const prevMarker = this.markers.find(m => m.isOpen);
        if (prevMarker) {
            prevMarker.infoWindow.close();
            prevMarker.isOpen = false;
            const defaultPin = this.GeneralOptions.map_marker_icon || null;
            if (defaultPin) {
                prevMarker.setIcon(defaultPin);
            }
        }


        // find the company relative marker and open it
        const companyMarker = this.markers.find(m => m.company.id == company.id);
        companyMarker.infoWindow.open(this.getCanvas(), companyMarker);
        companyMarker.isOpen = true;

        const activePin = this.GeneralOptions.mapActiveMarkerIcon || null;

        if (activePin) {
            companyMarker.setIcon(activePin);
        }
        // close the accordion
        this.results.forEach((r) => {
            r.selected = false;
        });

        // open the relative accordion for this marker
        company.selected = true;


        this.getCanvas().setCenter({lat: company.address.lat, lng: company.address.long});
        // safely refresh the scope to apply accordion changes
        this.$timeout(() => {
            this.$scope.$apply();
        });

    }

    resetQuery() {
        this.query = null;
        document.getElementById('search-stores').focus();
    }

    drawMarkers(defaultMarkerIndex = 0) {
        const defaultPin = this.GeneralOptions.map_marker_icon || null;

        const pinHasLabel = this.GeneralOptions.mapMarkerHasLabel || null;

        this.results.forEach((company, index) => {

            // close company accordion
            company.selected = false;

            /**
             * We create a new scope from rootScope because we are going to compile a component runtime.
             * Using rootscope instead of scope means that the compile scope is a rootScope direct child with no
             * other ancestors, and it's easier to access to data in the component controller itself
             * @type {*}
             */
            const scope = this.$rootScope.$new();
            scope.company = company;

            const iW = this.$compile(angular.element(`<company-details-component company="company"show-name="true">
            </company-details-component>`))(scope);

            // Compile is async, so safely wait for it
            this.$timeout(() => {

                const infoWindow = new google.maps.InfoWindow({
                    content: iW.html()
                });

                const marker = new google.maps.Marker({
                    position: {lat: company.address.lat, lng: company.address.long},
                    map: this.getCanvas(),
                });

                if (defaultPin) {
                    marker.setIcon(defaultPin);
                }

                // assign a label to the pin in order to easily match with the list
                if (pinHasLabel) {
                    marker.setLabel((index + 1).toString());
                }

                marker.company = company;
                marker.infoWindow = infoWindow;


                this.markers.push(marker);


                google.maps.event.addListener(marker, 'click', () => {
                    this.openInfo(company);
                });
            });

        });

        // Open the default marker/infowindow or a specific one
        this.$timeout(() => {
            this.markers[defaultMarkerIndex].isOpen = true;
            this.markers[defaultMarkerIndex].infoWindow.open(this.getCanvas(), this.markers[defaultMarkerIndex]);
            this.results[defaultMarkerIndex].selected = true;

            this.getCanvas().setZoom(this.defaultOptions.default_zoom);
            //this.ready = true;
            google.maps.event.trigger(this.getCanvas(), 'resize');
            this.loader.setLoaded();
        });
    }

    next(route = null) {
        this.loader.notLoaded();
        const selectedCompany = this.results.find(r => r.selected);

        if (this.BBWidget.current_item.service) {
            this.BBWidget.item_defaults.service = this.BBWidget.current_item.service.id;
        } else if (selectedCompany.service) {
            this.BBWidget.item_defaults.service = selectedCompany.service.id;
        }

        // copy&paste from the old controller
        const init_obj = {
            company_id: selectedCompany.id,
            item_defaults: this.BBWidget.item_defaults,
            no_route: false
        };
        if (route) {
            init_obj.first_page = route;
        }

        // Map state
        // let state = {
        //     query: this.query,
        //     selectedCompany: selectedCompany,
        //     results: this.results,
        //     markerIndex: this.markers.findIndex(m => m.isOpen)
        // };

        // let's keep the current state inside the session storage
        // sessionStorage.setItem('map_state', JSON.stringify(state));
        this.bbWidgetInit.initWidget(init_obj);
    }
}



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/map/map.controller.js